module.exports = __webpack_public_path__ + "44587aa0cde8d3d5a7ed5370181ea650.svg";